
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<div class="content d-flex justify-content-center align-items-center">
  <form class="login-form" [formGroup]="formArquivoSiope">
    <div class="card bg-dark mb-0 text-light">
      <div class="card-body">
        <div class="text-center mb-3">
          <h5 class="mb-0">Gerar Arquivo SIOPE</h5>
        </div>

        <div class="s-12 col-sm-12 col-md-12 col-lg-12 form-group">
          <label class="justify-content-start">Data Competência</label>
          <div class="input-group">
            <input
              formControlName="dtComp"
              type="text"
              class="form-control"
              placeholder="00/0000"
              mask="00/0000"
              maxlength="7"
              (keyup.enter)="gerarArquivo()"
            />
            <div class="input-group-append">
              <button (click)="gerarArquivo()" type="button" class="btn bg-primary border-primary">
                <i class="fa fa-download" aria-hidden="true"></i> Gerar
              </button>
            </div>
          </div>
          <small class="form-text text-muted">Digite a Competência</small>
        </div>
      </div>
    </div>
  </form>
</div>
